module.exports = __webpack_public_path__ + "img/back.c8716fd9.jpg";